import React from 'react';
import _ from 'lodash';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import ButtonGroup from '../components/common/ButtonGroup';
import Table from '../components/Table/Table';
import useGlobalPpis from '../features/PpiContainer/hooks/useGlobalPpis';
import { ppiCreateFromExistingRoute, ppiCreateRoute } from '../routes';
import { EnrichmentData, States } from '../features/PpiContainer/constants';
import { toJS } from '../utils/immutableUtils';
import usePpis from '../features/PpiContainer/hooks/usePpis';
import columns from '../features/PpiContainer/ui/columns';
import ProgressFullscreen from '../components/common/ProgressFullscreen';
import View from './views';
import PaperContainer from '../components/common/PaperContainer';
import useIngredients from '../features/IngredientContainer/hooks/useIngredients';
import { getMarketName } from '../features/app/selectors';

const PpiColumns = columns(EnrichmentData.PUBLISHED);
const GlobalPpiColumns = {
  PresentationName: {
    name: 'presentationName',
    dataField: 'publishedPPIEnrichmentData.info.EN-IF.presentationName',
    label: 'Product Name',
    width: 500,
    grow: 1,
    shrink: 1
  },
  CreatePpi: {
    name: 'createPpi',
    sortable: false,
    label: '',
    CellValue: ({ rowData }) => {
      if (!_.get(rowData, 'data.publishedPPIEnrichmentData.id')) {
        return null;
      }
      const { data } = rowData;
      return (
        <ButtonGroup
          route={ppiCreateFromExistingRoute(
            data.id,
            data.publishedPPIEnrichmentData.id,
            data.ppiItemCode === null ? data.itemCode : data.ppiItemCode
          )}
          menuItems={[
            {
              text: <FormattedMessage id="ppi.createInstruction" />,
              route: ppiCreateRoute(
                data.ppiItemCode === null ? data.itemCode : data.ppiItemCode
              )
            }
          ]}
        >
          <FormattedMessage id="ppi.copyInstruction" />
        </ButtonGroup>
      );
    },
    width: 200,
    grow: 0,
    shrink: 0
  }
};

/**
 * Excludes PPIs provided in the parameter "excludePpis" from the original list
 * @param ppis Array of PPIs to exclude PPIs from
 * @param ppisToExclude Array of PPIS to exclude
 */
function excludePpis(ppis, ppisToExclude) {
  const excludeItemCodes = ppisToExclude.map(localPpi => localPpi.itemCode);
  return ppis.filter(ppi => {
    return !excludeItemCodes.includes(ppi.itemCode);
  });
}

/**
 * View showing Global PPIs to create local versions from.
 * @returns {*}
 * @constructor
 */
// TODO Consider if global ingredients should be used as rows. What happens if global hasn't created a PPI just yet, then nothing is shown to the user ?
const NewIngredientsGlobalView = () => {
  const [isFetchingGlobal, globalPpisRaw] = useGlobalPpis({
    status: States.PUBLISHED
  });
  const [isFetchingLocal, localPpisRaw] = usePpis();
  const globalPpis = toJS(globalPpisRaw, []);
  const localPpis = toJS(localPpisRaw, []);
  const currOrganization = useSelector(getMarketName);
  // console.log("currOrganization",currOrganization)
  const [isFetching, ingredientsRaw] = useIngredients({ hasPpi: false });
  // console.log("ingredients",ingredientsRaw)
  const ingredients = toJS(ingredientsRaw, []);

  if (isFetchingLocal || isFetchingGlobal || isFetching) {
    return <ProgressFullscreen />;
  }

  const globalPpisWithoutLocalPpi = excludePpis(globalPpis, localPpis);

  // console.log("globalPpisWithoutLocalPpi",globalPpisWithoutLocalPpi)

  let globalPpisWithPPIItemCode = globalPpisWithoutLocalPpi;

  if (ingredients.length > 0 && globalPpisWithoutLocalPpi.length > 0) {
    for (var i = 0; i < globalPpisWithoutLocalPpi.length; i++) {
      const filteredList = ingredients.filter(item => {
        return item.relationshipId === globalPpisWithoutLocalPpi[i].itemCode;
      });
      if (filteredList.length > 0) {
        //  globalPpisWithoutLocalPpi[i].ppi = filteredList[0];
        // console.log(filteredList[0].itemCode)
        globalPpisWithoutLocalPpi[i].ppiItemCode = filteredList[0].itemCode;
      } else {
        globalPpisWithoutLocalPpi[i].ppiItemCode = null;
        // globalPpisWithoutLocalPpi.splice(i,1);
        // console.log(globalPpisWithoutLocalPpi,i)
      }
    }
  }

  globalPpisWithPPIItemCode = globalPpisWithoutLocalPpi.filter(item => {
    if (item.ppiItemCode !== null) {
      return item;
    }
  });

  //  console.log("globalPpisWithPPIItemCode",globalPpisWithPPIItemCode)

  View.NewIngredientsView.visit();

  return (
    <PaperContainer>
      <Table
        title="ingredient.newGlobalIngredientsTableTitle"
        data={globalPpisWithPPIItemCode}
        columns={[
          PpiColumns.MarketFoodID,
          PpiColumns.IFoodID,
          GlobalPpiColumns.PresentationName,
          PpiColumns.ActualPublishedDate,
          PpiColumns.PublishedBy,
          GlobalPpiColumns.CreatePpi
        ]}
        getObjectId={object => object.id}
        defaultSorting={[{ columnName: 'presentationName', direction: 'asc' }]}
        selectable
        showLanguageSelector={false}
      />
    </PaperContainer>
  );
};

export default NewIngredientsGlobalView;
